<template>
  <div class="BxList">
    <oButton class="btnSubmit" @click="hdlBackToForm" buttonText="New Registry" />
    <transition name="zoom" mode="out-in" appear>
      <LoadAnimation v-if="loading" :loadSettings="loadSettings" />
      <div v-else-if="!deploymentList" class="msg-refresh">
        <svg class="fa fa-sync"></svg>
        <span>{{msg}}</span>
      </div>
      <ul v-else>
        <h3>Deployments:</h3>
        <li v-for="deployment in sortDeploymentList" :key="deployment.id">
          <p>{{deployment.customerName}}</p>
          <span class="vnext-flag" v-show ="deployment.webVersionName == 'vNext'">{{ deployment.webVersionName }}</span>
          <span class="postpone-flag" v-show ="deployment.vNextMigration == 'Postponed'">Postponed</span>
          <span class="ready-flag" v-show="deployment.vNextMigration == 'Prepared'">Ready</span>
          <svg v-show ="deployment.vNextMigration == 'ActionRequired'" class="fa fa-exclamation-circle"></svg>
          <oButton @click="hdlEdit(deployment)" buttonText="Edit" />
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import oButton from './oButton'
import LoadAnimation from './LoadAnimation'
// import deployments from '../assets/data/data.js'

export default {
  name: 'BxList',
  components: {
    oButton,
    LoadAnimation,
  },
  props: ['token'],
  data() {
    return {
      userToken: this.token,
      msg: 'Refresh to see the list',
      deploymentList: this.deploymentList || '',
      loading: false,
      loadSettings: this.loadSettings || {
        animationStyle: 'zoom',
        message: 'This may take a while..',
      },
    }
  },
  created() {
    if (sessionStorage && sessionStorage.getItem('list'))
      this.deploymentList = JSON.parse(sessionStorage.getItem('list'))
    this.hdlGetList()
  },
  watch: {
    $route(to, from) {
      if (to.name == 'list') {
        this.hdlGetList()
      }
    },
  },
  computed:{
    sortDeploymentList(){
      return this.deploymentList ? [...this.deploymentList].sort((a, b) => (a.customerName.toLowerCase() > b.customerName.toLowerCase() ? 1 : -1)) : []
    }
  },
  methods: {
    hdlBackToForm() {
      this.$emit('change', {
        hybridConnection: false,
        hybridConnectionHost: '',
        hybridConnectionPort: 0,
        authentication: 'aad',
        appControlMergeFile:
          'App.NAV.WS.xml?{DebugLog}=false;{FormsTestSite}=false;{PurchaseDisabled}=true;{UseNAVSSOEmailing}=true',
        formsTestSitePassword: '',
        deployType: 'npe',
      })
      this.$router.push({ name: 'vnext' })
    },
    hdlGetList() {
      this.loading = true
      this.$http('api/register/list', 'GET', this.token)
        .then(data => {
          this.loading = false
          sessionStorage.setItem('list', JSON.stringify(data))
          this.deploymentList = data
        })
        .catch(error => {
          if (error.status === 401) {
            this.loading = false
            this.$emit('getUser', '')
            this.$emit('getToken', '')
            sessionStorage.clear()
            this.$toasted.global.error_login(
              'You are not Authorized. Token might have expired. Please log in again'
            )
          } else if (error.status === 404) {
            this.loading = false
            this.$toasted.global.error_message({message:'Deployment Not Found'})
          } else {
            this.loading = false
            this.$toasted.global.error_message()
          }
        })
    },
    hdlEdit(deployment) {
      this.loading = true
      let edit = this.$http('api/register/edit', 'POST', this.token, deployment)
        .then(data => {
          this.loading = false
          this.$emit('change', data)
          this.$emit('disableInput', data)
        }).then( s => {
          this.$router.push({ name: 'register' })
        }
        )
        .catch(error => {
          this.loading = false
          this.$toasted.global.error_message()
        })

    },
  },
}
</script>

<style scoped>
.BxList {
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 200px;
  background-color: var(--o-text-on-bg);
  min-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--o-primary) var(--o-bg1);
}
h3 {
    color: var(--o-text);
    font-weight: 400;
}
span {
  text-align: center;
  padding: 10px;
  opacity: 0.4;
}
ul {
  list-style-type: none;
  padding: 10px;
  width: 100%;
}
li {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.07);
  margin: 0 15px 5px 15px;
}
.vnext-flag {
  background-color: var(--o-success);
  opacity: 1;
  padding: 5px;
  color: white;
}
.postpone-flag{
  background-color: var(--o-processing);
  opacity: 1;
  padding: 5px;
  color: white;
}
.ready-flag{
  opacity: 1;
  padding: 5px;
  color:var(--o-success);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.btnSubmit {
  align-self: flex-end;
  margin-bottom: 10px;
  margin-right: 10px;
}
.fa-sync {
  color: var(--o-disable);
  font-size: 30px;
}
.fa-exclamation-circle{
  color: var(--o-suspended);
  font-size: 20px;
}
.msg-refresh {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 130px;
}
@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
.zoom-enter-active {
  animation: zoomIn 0.3s;
}
.zoom-leave-active {
  animation: zoomIn 0.3s reverse;
}
/* ================================= 
  Media Queries
==================================== */

@media (min-width: 769px) {
  .BxList {
    max-width: 800px;
    min-height: 500px;
    padding: 15px;
    height: 100%;
    max-height: 600px;
  }
  .BxList::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  .BxList::-webkit-scrollbar-track{
    background-color: var(--o-bg1);
  }
  .BxList::-webkit-scrollbar-thumb{
    background-color: var(--o-primary);
  }
  .btnSubmit {
    margin-bottom: 0;
    margin-right: 0;
  }
  .msg-refresh {
    margin-top: 160px;
  }
}
@media (min-width: 1025px) {
  .BxList {
    max-width: 800px;
    min-height: 500px;
    padding: 20px;
    height: 100%;
    max-height: 600px;
  }
  .BxList::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  .BxList::-webkit-scrollbar-track{
    background-color: var(--o-bg1);
  }
  .BxList::-webkit-scrollbar-thumb{
    background-color: var(--o-primary);
  }
  ul {
    max-width: 80%;
    margin: 0 auto;
  }
  .btnSubmit {
    margin-bottom: 0;
    margin-right: 0;
  }
  .msg-refresh {
    margin-top: 160px;
  }
}
</style>